import React, { useState, useEffect, useRef } from "react";
import { notification, Spin, Popconfirm, Tooltip } from 'antd';
import Modal from "../../components/uiComponent/modal/index";
import XLSX from 'xlsx';
import downloadCsv from 'download-csv';
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { round, debounce, ceil, isElement, isEmpty, compact, filter } from "lodash";
import { WarehouseWrapper } from "./style";
import Select from "../../components/uiComponent/select/index";
import AgGrid from "../../components/ag-grid-table/index";
import { BsPencilSquare, BsTrash, BsPlus, BsSearch, BsClockHistory } from "react-icons/bs";
import WarnIcon from "../../assets/icons/warning-modal-icon.svg"
import Button from "../../components/uiComponent/button/index";
import Drawer from "../../components/uiComponent/drawer/index";
import Input from "../../components/uiComponent/inputs/labelInput/index"
import Pagination from "../../components/pagination/index";
import SearchInput from "../../components/uiComponent/inputs/searchinput/index";
import { GetPresignedUrl  } from '../../slices/aws-services';
import { setItem } from '../../slices/auth';
import { generateStorageBarcode, generateZebraLabels, generate30UpLabels } from '../../utils/locationLabels';
import { convertUtcToEst } from "../../utils/helpers";

import {
  GetLocations,
  AddLocation,
  UpdateLocation,
  AddBulkLocations,
  DeleteLocation
} from '../../slices/location-management';

import Stepper from '../../components/uiComponent/stepper/index';
import AddManualProduct from "./addProductModal";
import BulkAddInventory from "./bulk-add-inventory";
import InitialInventory from "./initial-inventory";

let gridColumnApi;

const Index = () => {
  const submitFormRef = useRef(null);
  const dispatch = useDispatch();
  const searchRef = useRef(null);
  const navigate = useNavigate();

  const {
    locations = [],
    locationsCount,
    getLocationsLoading,
    createLocationLoading,
    updateLocationLoading,
    bulkLocationsLoading,
    deleteLocationLoading,
    fileUrl,
    addInventoryFileUrl
  } = useSelector(state => state?.locationManagement || {});

  const {
    loading
  } = useSelector(state => state?.awsServices || {})
  const {
    warehouseUsers,
    userWarehouses
  } = useSelector(state => state?.internalStorage || {});

  const { showFileHeader } = useSelector(state => state?.auth || {});

  const [activeStep, setActiveStep] = useState(0);
  const [upload, setUpload] = useState(false);
  const [progress, setProgress] = useState(0);
  const [location, setLocation] = useState({
    name: '',
    selectedId: ''
  });

  const [bulkAddInventory, setBulkAddInventory] = useState(false);
  const [initialInventory, setInitialInventory] = useState(false);
  const [filters, setFilters] = useState({
    warehouse: null,
    userName: null,
    searchValue: null,
    pagination: {
      pageNumber: 1,
      pageLimit: 25
    },
    sortBy: { key: '', type: '' }
  });

  const [open, setOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataToBeDelete, setDataToBeDelete] = useState({});
  const [editLocation, setEditLocation] = useState(false);
  const [addLocation, setAddLocation] = useState(false);
  const [addProduct, setAddProduct] = useState(false);
  // const [openSearch, setOpenSearch] = useState(false);

  const { name } = location;
  const { pagination, warehouse, userName, searchValue } = filters || {};
  const { pageNumber, pageLimit } = pagination || {};

  const openEditModule = (event, data) => {
    const { id, name } = data;
    setLocation({
      name: name,
      selectedId: id
    });
    setEditLocation(true);
  }

  useEffect(() => {
    dispatch(GetLocations(filters));
  }, []);

  const handleDownloadLocationLabel = (event, data) => {
    const { id: uuid, name, warehouse_user } = data || {};
    generateStorageBarcode({
      warehouseName: warehouse_user || '',
      locationName: name,
      uuid,
      labelType: 'location'
    })
  }

  const handleDeleteLocation = async (data) => {
    const { id } = dataToBeDelete;
    const response = await dispatch(DeleteLocation({ locationId: id }))
    setDeleteModal(false);
    if (isEmpty(response.error)) {
      dispatch(GetLocations(filters));
      setDeleteModal(false);
      clearLocationStates();
    }
  }

  const openDeleteModal = (data) => {
    setDataToBeDelete(data);
    setDeleteModal(true);
  }

  const columnDefinitions = [
    {
      headerName: "Location Name",
      field: 'name',
      width: 257,
      flex: 1,
      sortable: false,
      cellRenderer: ({ value }) =>
        value ? value : "N/A",
    },
    {
      headerName: "Products",
      field: 'total_products',
      width: 105,
      flex: 1,
      sortable: true,
      comparator : ()=> 0,
      cellRenderer: ({ value }) => (value ? value : 0),
    },
    {
      headerName: "Units",
      field: 'total_qty',
      width: 85,
      flex: 1,
      sortable: true,
      cellRenderer: ({ value }) => (value ? value : 0),
      comparator : ()=> 0
    },
    {
      headerName: "Created Date",
      field: 'created_at',
      minWidth: 128,
      flex: 1,
      sortable: true,
      comparator : ()=> '',
      cellRenderer: ({ value }) => {
        if (value) {
          return convertUtcToEst(value, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })
        }
        return 'N/A';
      }
    },
    {
      headerName: "Updated Date",
      field: 'updated_at',
      minWidth: 105,
      flex: 1,
      sortable: true,
      comparator : ()=> '',
      cellRenderer: ({ value }) => {
        if (value) {
          return convertUtcToEst(value, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })
        }
        return 'N/A';
      }
    },
    {
      headerName: "Actions",
      field: 'email',
      pinned: "right",
      align: 'center',
      sortable:false,
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClass: 'ag-center-aligned-header',
      cellClass: 'ag-center-aligned-cell',
      headerStyle: { textAlign: 'center' },
      cellRendererFramework: ({ data }) => {
        const { total_products, name = '' } = data || {};
        const deleteConfirm = total_products !== 0;
        let disabledLocation = false;
        if (name === 'staging-location') disabledLocation = true;
        return (
          <div
            className="d-flex align-items-center table-icon gap-3 "
            style={{ width: '100%', justifyContent: 'center' }}
          >
            <Tooltip title={deleteConfirm ? 'Cannot delete this location while items are assigned to it' : disabledLocation ? 'You Cannot Delete Staging Location' : 'Delete'}>
              <BsTrash className={`${deleteConfirm ? '' : 'cursor-pointer'} color-danger`} onClick={() => !deleteConfirm && !disabledLocation && openDeleteModal(data)} />
            </Tooltip>
            <Tooltip title='Download Label'>
              <span className="icon-print cursor-pointer" onClick={(e) => handleDownloadLocationLabel(e, data)}></span>
            </Tooltip>
            <Tooltip title= { disabledLocation ? 'You Cannot Edit Name Of Staging Location' : 'Edit Name' } >
              <BsPencilSquare  className="color-primary cursor-pointer" onClick={(e) => !disabledLocation && openEditModule(e, data)} />
            </Tooltip>
            {/* <Tooltip title='Go to histories'>
              <BsClockHistory className="color-primary cursor-pointer" onClick={() => selectLocationAndRedirect(data, 'locations-history')} />
            </Tooltip> */}
            <Tooltip title='Go to Items'>
              <span onClick={() => selectLocationAndRedirect(data, 'location-names')}
                className="icon-arrow-right cursor-pointer"
              ></span>

            </Tooltip>
          </div>
        );
      },
    },
  ];

  const selectLocationAndRedirect = (selectedLocation, url) => {
    const { id, name } = selectedLocation || {};
    if (url === 'locations-history') navigate(`/${url}?id=${name}`);
    else navigate(`/${url}?id=${id}`);
  }

  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    sortable: true,
    // headerCheckboxSelection: isFirstColumn,
    // checkboxSelection: isFirstColumn,
  };

  const updateLocationFields = (key, value) => {
    setLocation({
      ...location,
      [key]: value
    });
  }

  const handleUpdateLocation = async () => {
    const { name, selectedId } = location;
    if (name && selectedId) {
      const response = await dispatch(UpdateLocation({ id: selectedId, name }))
      if (isEmpty(response.error)) {
        dispatch(GetLocations(filters));
        clearLocationStates();
      }
    }
  }

  const handleUploadNewLocation = async () => {
    const { name } = location;
    if (name) {
      const response = await dispatch(AddLocation({ name }));
      if (isEmpty(response.error)) {
        clearLocationStates();
        dispatch(GetLocations(filters));
      }
    }
  }

  const handlePagination = (number, key) => {
    const value = Number(number);
    let filter = { ...filters }
    if (key === 'pageLimit') filter = { ...filters, pagination: { pageNumber: 1, pageLimit: value } };
    else filter = { ...filters, pagination: { ...pagination, pageNumber: value } };
    setFilters(filter);
    dispatch(GetLocations(filter));
  }

  const handleDropdownValue = (data, key) => {
    const { value = null } = data || {};
    const filter = { ...filters, pagination: { ...pagination, pageNumber: 1 }, [key]: value };
    setFilters(filter)
    dispatch(GetLocations(filter));
  }

  const handleSearchValue = debounce((event) => {
    const { value } = event?.target || null;
    const filter = { ...filters, pagination: { ...pagination, pageNumber: 1 }, searchValue: value };
    setFilters(filter)
    dispatch(GetLocations(filter));
  }, 1000)

  const warehouseOptions = warehouseUsers?.map((warehouse) => {
    const { id, warehouse_name } = warehouse || {};
    return {
      value: id,
      label: warehouse_name
    };
  });

  const usersOptions = userWarehouses?.map((user) => {
    const { id, full_name } = user || {};
    return {
      value: id,
      label: full_name
    };
  });

  const handleUploadfile = async (e, isZebraLabel) => {
    const file = e[0]?.originFileObj;
    dispatch(setItem({
      field: 'showFileHeader',
      value: false
    }));
    const uploadedFile = await dispatch(GetPresignedUrl({ files: [file] }))
    setActiveStep(2);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    let fileJson = [];
    reader.onload = (async ({ target }) => {
      const wb = XLSX.read(target.result, { type: 'binary', raw: true });
      wb.SheetNames.forEach((sheetName) => {
        fileJson = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 2, defval: "" })
      });
      if (!isEmpty(fileJson)) {
        let locationNames = fileJson.map((item) => item.Location_Name);
        locationNames = compact(locationNames);
        if (!isEmpty(locationNames)) {
          const response = await dispatch(AddBulkLocations({ locations: locationNames, fileName: file.name, originalUrl: uploadedFile.payload[0]?.url  }));
          setTimeout(() => {
            dispatch(setItem({
              field: 'showFileHeader',
              value: true
            }));
          }, 1000);

          if (isEmpty(response.error)) {
            const locations = response?.payload?.data?.locations || [];
            isZebraLabel ? generateZebraLabels({ locations }) : generate30UpLabels({ locations });
            await dispatch(GetLocations(filters));
            setActiveStep(3);
          } else setActiveStep(0);
        } else {
          notification.error({
            message: 'Please Ensure Your File Matches The Sample Format'
          })
          setActiveStep(0);
        }
      } else {
        notification.error({
          message: 'The Uploaded File Is Empty'
        })
        setActiveStep(0);
      }
    });
  };

  const downloadSampleTemplate = () => {
    const dummyData = [{
      locationName: 'sample_location'
    }];
    const headers = { locationName: 'Location_Name' }
    downloadCsv(dummyData, headers, 'location_sample.csv');
  }

  const handleOpenBulkDrawer = () => {
    setUpload(true);
    setActiveStep(0);
  }

  const refreshGridClick = () => {
    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true,
      });
    }
    const updatedFilters = {
      ...filters,
      pagination: {
        ...filters.pagination,
        pageNumber: 1,
      }
    };
    setFilters(updatedFilters);
    dispatch(GetLocations(updatedFilters));
  };

  const handleLocationAddDrawer = async () => {
    setLocation({ name: '' });
    setOpen(true);
    setAddLocation(true);
  }

  const clearLocationStates = () => {
    setLocation({ name: '', selectedId: '' });
    setAddLocation(false);
    setEditLocation(false);
    setDeleteModal(false);
    setUpload(false);
    setActiveStep(0);
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null)

    if (value && ['total_qty', 'total_products', 'created_at', 'updated_at'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      filters.sortBy = { key: colId, type: sort };
        dispatch(GetLocations(filters));
    }
  }
  const gridReady = (params) => {
    gridColumnApi = params.columnApi
  };


  const addDisable = isEmpty(name) || createLocationLoading;
  const updateDisable = isEmpty(name) || updateLocationLoading;

  return (
    <WarehouseWrapper>
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-3 align-items-center">
          <h2 className="color-secondary mb-0">Warehouse Locations</h2>
        </div>
        <div className="d-flex align-items-center gap-4">
          <div className="d-flex gap-3">
            {/* <Select
              isClearable={true}
              className="w-188"
              placeholder="Select User"
              defaultValue={userName}
              onChange={(event) => handleDropdownValue(event, 'userName')}
              options={usersOptions}
            /> */}
            {/* {
              true
              ? 
                <Select
                  isClearable={true}
                  className="w-188"
                  placeholder="Select User"
                  defaultValue={userName}
                  onChange={(event) => handleDropdownValue(event, 'userName')}
                  options={usersOptions}
                />
              : <Select
                  isClearable={true}
                  className="w-188"
                  placeholder="Select Warehouse"
                  defaultValue={warehouse}
                  onChange={(event) => handleDropdownValue(event, 'warehouse')}
                  options={warehouseOptions}
                />
              } */}
          </div>
          <div className="d-flex gap-3">
               <Button
              text="Initial Inventory"
              className="outlined mb-0"
              startIcon={<span className="icon-upload-bulk pr-8 "></span>}
              onClick={() => setInitialInventory(true)}
            />
          <Button
              text="Bulk Add Inventory"
              className="outlined mb-0"
              startIcon={<span className="icon-upload-bulk pr-8 "></span>}
              onClick={() =>  setBulkAddInventory(true)}
              innerButton={(addInventoryFileUrl && showFileHeader) ? true : false}
              innerButtonText={(addInventoryFileUrl && showFileHeader) ? "Download Errors" : ""}
              fileUrl={addInventoryFileUrl}

            />
         
            <Button
              text="Bulk Adjustment"
              className="outlined mb-0"
              startIcon={<span className="icon-upload-bulk pr-8 "></span>}
              onClick={() =>  setAddProduct(true)}
              innerButton={(fileUrl && showFileHeader) ? true : false}
              innerButtonText={(fileUrl && showFileHeader) ? "Download Errors" : ""}
              fileUrl={fileUrl}
            
            />
            <Button
              text="Upload Bulk Locations"
              className="outlined mb-0"
              startIcon={<span className="icon-upload-bulk pr-8 "></span>}
              onClick={handleOpenBulkDrawer}
            />
            <Button
              text="Add Location"
              className="outlined mb-0"
              startIcon={<span className="icon-add pr-8"></span>}
              onClick={() => setAddLocation(true)}
            />
            {/* <Tooltip title='Items which was received but never assigned a location'>
              <div>
                <Button
                  text="Unassigned Items"
                  className="outlined mb-0"
                  startIcon={<span className="pr-8"></span>}
                  onClick={() => navigate(`/location-names?id=unassigned`)}
                />
              </div>
            </Tooltip> */}
            {/* <Button
              text="Go To histories"
              className="outlined mb-0"
              startIcon={<span className="pr-8"></span>}
              onClick={() => navigate('/locations-history')}
            /> */}
            <SearchInput defaultValue={searchValue} placeholder="Location Name" onChange={handleSearchValue} />
          </div>
        </div>
      </div>
      <div>
        <Spin tip="Processing..." spinning={getLocationsLoading}>
          <AgGrid
            gridReady={gridReady}
            user_referrals={locations}
            defaultColDef={defaultColDef}
            columnDefinitions={columnDefinitions}
            rowHeight={40}
            onSortChange={onSortChange}
            className="warehouse-location"
            height="164px"
          />
        </Spin>
      </div>
      <Pagination
        total={locationsCount}
        totalPages={ceil(locationsCount / pageLimit + 1)}
        pageNumber={pageNumber}
        pageLimit={pageLimit}
        handleLimitChange={(e) => handlePagination(e, 'pageLimit')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
      />
      <Modal
        open={upload}
        onHide={() => setUpload(false)}
        onClose={() => setUpload(false)}
        header={false}
        closeButton={false}
        buttonDisabled={false}
        size="md"
        removeIcon
        className="delete-confirmation-modal"
        centerAlign={false}
      >
        <WarehouseWrapper className="wear-house-wrapper-ui">
          <div className="drawer-padding drawer-overflow">
            <div className="d-flex align-items-center grid-column-gap-10">
              {/* <span
              className="icon-arrow-left cursor-pointer"
              onClick={() => setUpload(false)}
              ></span> */}
              <h2 className="mb-0">Add Bulk Locations</h2>
              </div>
            <div className="upload-description">
              <p className="">To add multiple locations, you can upload a CSV or Excel file with location names.</p>
            </div>
            <Stepper
              loading={bulkLocationsLoading || loading }
              onChange={(e, isZebraLabel) => handleUploadfile(e, isZebraLabel)}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              onClick={() => {
                setActiveStep(0);
                setUpload(false);
              }}
              uploadBulkLoading={bulkLocationsLoading}
              onCancel={clearLocationStates}
              downloadSampleTemplate={downloadSampleTemplate}
            />
          </div>
        </WarehouseWrapper>
      </Modal>
      <Modal
        open={addLocation}
        onHide={() => clearLocationStates()}
        onClose={() => clearLocationStates()}
        header={false}
        closeButton={false}
        buttonDisabled={false}
        size="sm"
        removeIcon
        className="delete-confirmation-modal"
        centerAlign={false}
      >
        <Spin tip="Adding.." spinning={createLocationLoading}>
          <WarehouseWrapper>
            <div className="edit-modal-wrapper">
              <h2 className="mb-0">Add Location</h2>
              <div className="mt-3">
                <Input label="Location Name" value={name} className="h-32" placeholder="Enter" onChange={(e) => updateLocationFields('name', e.target.value)} />
              </div>
              {/* <div className="mt-3"> */}
              {/* <Input label="Location Type" className="h-32" placeholder="Location Type" onChange={(e) => updateLocationFields('type', e.target.value)} /> */}
              {/* </div> */}
            </div>
            <div className="d-flex gap-3 justify-content-center">
              <Button onClick={() => clearLocationStates()} className="w-100 outlined" text="Cancel" />
              <Button className="w-100" disabled={addDisable || !location?.name} text={createLocationLoading ? "Adding..." : "Add Location"} onClick={handleUploadNewLocation} />
            </div>
          </WarehouseWrapper>
        </Spin>
      </Modal>
      <Modal
        open={editLocation}
        onHide={() => clearLocationStates()}
        onClose={() => clearLocationStates()}
        onSave={handleUpdateLocation}
        header={false}
        closeButton={false}
        buttonDisabled={false}
        size="sm"
        removeIcon
        className="delete-confirmation-modal"
        centerAlign={false}
      >
        <Spin tip="Updating Name.." spinning={updateLocationLoading}>
          <WarehouseWrapper>
            <div className="edit-modal-wrapper">
              <h2 className="mb-0">Update Location</h2>
              <Input required label="Location Name" value={name} className="h-32" placeholder="Enter" onChange={(e) => updateLocationFields('name', e.target.value)} />
              {/* <Input label="Location Type" value={type} className="h-32" placeholder="Location Type" onChange={(e) => updateLocationFields('type', e.target.value)}/>   */}
            </div>
            <div className="d-flex gap-3 justify-content-center">
              <Button onClick={() => clearLocationStates()} className="w-100 outlined" text="Cancel" />
              <Button className="w-100" disabled={updateDisable} text={updateLocationLoading ? "Updating Location" : "Update Location"} onClick={handleUpdateLocation} />
            </div>
          </WarehouseWrapper>
        </Spin>
      </Modal>
      <Modal
        open={deleteModal}
        onHide={() => clearLocationStates()}
        onClose={() => clearLocationStates()}
        onSave={handleDeleteLocation}
        header={true}
        closeText="Cancel"
        saveText={deleteLocationLoading ? 'Deleting' : "Confirm"}
        closeButton={true}
        buttonDisabled={deleteLocationLoading}
        size="md"
        className="delete-confirmation-modal"
        centerAlign={false}
      >
        <Spin tip="Deleting" spinning={deleteLocationLoading}>
          <WarehouseWrapper>
            <div className='delete-modal-wrapper'>
              <img src={WarnIcon} alt={WarnIcon} title={WarnIcon} className="color-danger" />
              <h3 className="mt-4">Warning</h3>
              <p>Are you sure you want to delete Location?</p>
            </div>
          </WarehouseWrapper>
        </Spin>
      </Modal>
      <AddManualProduct addProduct={addProduct} setAddProduct={setAddProduct} refreshGridClick={refreshGridClick} />
      <BulkAddInventory addProduct={bulkAddInventory} setAddProduct={setBulkAddInventory} refreshGridClick={refreshGridClick} />
      <InitialInventory addProduct={initialInventory} setAddProduct={setInitialInventory} refreshGridClick={refreshGridClick} />
    </WarehouseWrapper>
  );
};

export default Index;